import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { authUser } from '../Context/UserContext';


const Navbar = () => {
    const { user, logutOut } = useContext(authUser);

    const navItems = <>
        <li><NavLink to='/home'>Home</NavLink></li>
        {user ?
            <li><NavLink to='/addservices'>Add service</NavLink></li> : null}
        {user ?
            <li><NavLink to='/myreviews'>My reviews</NavLink></li> : null}

        <li><NavLink to='/blog'>blog</NavLink></li>
    </>

    return (
        <div className="navbar bg-base-100 shadow-lg ">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {navItems}
                    </ul>
                </div>
                <Link to='/' className="btn btn-ghost ml-20 normal-case text-xl">Food Zone</Link>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    {navItems}
                </ul>
            </div>
            <div className="mx-auto">
                {user ?
                    <div className="tooltip tooltip-left " data-tip={user?.displayName}>
                        <div className="dropdown dropdown-end">
                            <label tabIndex={0} className="btn btn-ghost btn-circle avatar ">
                                <div className="w-10 rounded-full">
                                    <img src={user?.photoURL} alt='img' />
                                </div>
                            </label>
                            <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-400 rounded-box w-52">
                                <button className=' text-red-400' onClick={logutOut}>Logout</button>
                            </ul>
                        </div>
                    </div>
                    : undefined}
            </div>
        </div>
    );
};

export default Navbar;